import React from 'react';
import AntSpin, { SpinProps as AntSpinProps } from 'antd/lib/spin';
import './Spin.less';
import Styles from './Spin.module.less';

export type SpinProps = AntSpinProps;

export const Spin = (props: SpinProps): JSX.Element => (
    <AntSpin prefixCls={Styles.spin} {...props} />
);
